import React from "react";

function Tr({ className, onClickRow, item, children }) {
  if (onClickRow && typeof onClickRow === "function") {
    return (
      <tr className={className} onClick={() => onClickRow(item)}>
        {children}
      </tr>
    );
  } else {
    return <tr className={className}>{children}</tr>;
  }
}

export default Tr;
